import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import ImgStepThree from "../../../../../assets/Images/CarePlan3A.jpg";
import AllergyModal from "../modals/AddAllergyModal";

export default function Allergies() {
  const { t } = useTranslation();
  const [allergies, setAllergies] = useState([]);
  const [openModal, setOpenModal] = useState(false);

  // Agregar una alergia
  const handleSaveAllergy = (newAllergy) => {
    setAllergies([...allergies, newAllergy]);
  };

  // Eliminar una alergia
  const handleRemoveAllergy = (id) => {
    setAllergies(allergies.filter((allergy) => allergy.id !== id));
  };

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: 2,
        boxShadow: 3,
        overflow: "hidden",
        width: "100%",
      }}
    >
      {/* Header azul */}
      <Box
        sx={{
          backgroundColor: "#085394",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
        }}
      >
        {/* Título dentro de un recuadro blanco */}
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: 1,
            px: 2,
            py: 1,
            display: "inline-block",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              color: "#085394",
              textTransform: "uppercase",
              m: 0,
            }}
          >
            {t("CarePlan.createCarePlanHdr.wizard.stepThree")}
          </Typography>
        </Box>

        {/* Imagen a la derecha */}
        <Box sx={{ ml: 2 }}>
          <img
            src={ImgStepThree}
            alt="Alergias"
            style={{ width: "120px", borderRadius: "8px" }}
          />
        </Box>
      </Box>

      {/* Contenido principal (tabla y botón) */}
      <Box sx={{ p: 3 }}>
        <TableContainer component={Paper} sx={{ mb: 3, boxShadow: 3 }}>
          <Table>
            <TableHead sx={{ backgroundColor: "#085394" }}>
              <TableRow>
              {["id", "allergyDate", "allergy", "status", "action"].map((key) => (
                  <TableCell key={key} sx={{ color: "#fff", fontWeight: "bold" }}>
                    {t(`CarePlan.allergy.table.${key}`)}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {allergies.length > 0 ? (
                allergies.map((allergy) => (
                  <TableRow key={allergy.id}>
                    <TableCell>{allergy.id}</TableCell>
                    <TableCell>{allergy.date}</TableCell>
                    <TableCell>{allergy.name}</TableCell>
                    <TableCell>{allergy.status}</TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => handleRemoveAllergy(allergy.id)}
                        sx={{
                          color: "red",
                          "&:hover": { backgroundColor: "#FFEBEE" },
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    {t("CarePlan.allergy.noRecords")}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Botón Agregar Alergia */}
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setOpenModal(true)}
          sx={{
            backgroundColor: "#085394",
            "&:hover": { backgroundColor: "#064372" },
          }}
        >
          {t("CarePlan.allergy.addAllergy")}
        </Button>

        {/* Modal de Alergias */}
        <AllergyModal
          open={openModal}
          onClose={() => setOpenModal(false)}
          onSave={handleSaveAllergy}
        />
      </Box>
    </Box>
  );
}
